import { useState } from "react";
import { Link } from "react-router-dom";
import {
    Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis,
    ResponsiveContainer, Legend, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid
} from "recharts";
import { methods, metricLabels } from "../data/methodsData";

const colors = ["#ffb606", "#7c3aed", "#10b981", "#ef4444", "#3b82f6", "#f97316", "#06b6d4"];

function MethodCompare() {
    const [selected, setSelected] = useState(["3I", "GRASPS", "SMART"]);

    const toggle = (id) => {
        if (selected.includes(id)) {
            setSelected(selected.filter((s) => s !== id));
        } else if (selected.length < 4) {
            setSelected([...selected, id]);
        }
    };

    // Radar uchun data: har bir mezon — qator, ustunlar — tanlangan metodlar
    const radarData = Object.keys(metricLabels).map((key) => {
        const row = { metric: metricLabels[key] };
        selected.forEach((id) => {
            const m = methods.find((mm) => mm.id === id);
            if (m) row[m.name] = m.metrics[key];
        });
        return row;
    });

    // Bar chart uchun: o'rtacha ball
    const barData = methods.map((m) => {
        const vals = Object.values(m.metrics);
        const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
        return { name: m.id, "O'rtacha ball": Number(avg.toFixed(2)) };
    });

    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>Metodlarni qiyoslash</span></li>
                        </ul>
                        <h2 className="page-header__title">Metodlarni qiyosiy tahlili</h2>
                    </div>
                </div>
                <img src="/assets/images/page-header-shape-1.png" alt="shape" className="page-header__shape-one" />
                <img src="/assets/images/page-header-shape-2.png" alt="shape" className="page-header__shape-two" />
            </section>

            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Metodlarni 6 mezon bo'yicha taqqoslash</h3>
                                <p className="pricing-one__text">
                                    Quyidagi metodlardan 2-4 tasini tanlang — radar diagrammada qiyosiy tahlilini ko'ring.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div className="d-flex flex-wrap" style={{ gap: "10px", marginBottom: "30px" }}>
                                {methods.map((m, i) => {
                                    const active = selected.includes(m.id);
                                    return (
                                        <button
                                            key={m.id}
                                            onClick={() => toggle(m.id)}
                                            style={{
                                                padding: "10px 18px",
                                                borderRadius: "25px",
                                                border: `2px solid ${active ? colors[i] : "#ddd"}`,
                                                background: active ? colors[i] : "#fff",
                                                color: active ? "#fff" : "#333",
                                                cursor: "pointer",
                                                fontWeight: 600,
                                                transition: "all 0.2s"
                                            }}
                                        >
                                            {m.name}
                                        </button>
                                    );
                                })}
                            </div>

                            <div style={{ width: "100%", height: 500 }}>
                                <ResponsiveContainer>
                                    <RadarChart data={radarData}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="metric" style={{ fontSize: 13, fontWeight: 600 }} />
                                        <PolarRadiusAxis angle={90} domain={[0, 10]} />
                                        {selected.map((id, i) => {
                                            const m = methods.find((mm) => mm.id === id);
                                            return (
                                                <Radar
                                                    key={id}
                                                    name={m.name}
                                                    dataKey={m.name}
                                                    stroke={colors[methods.findIndex((mm) => mm.id === id)]}
                                                    fill={colors[methods.findIndex((mm) => mm.id === id)]}
                                                    fillOpacity={0.25}
                                                />
                                            );
                                        })}
                                        <Legend />
                                        <Tooltip />
                                    </RadarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>

                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Umumiy reyting</h3>
                                <p className="pricing-one__text">Barcha metodlarning o'rtacha ko'rsatkichi (1-10 shkala).</p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div style={{ width: "100%", height: 350 }}>
                                <ResponsiveContainer>
                                    <BarChart data={barData}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" />
                                        <YAxis domain={[0, 10]} />
                                        <Tooltip />
                                        <Bar dataKey="O'rtacha ball" fill="#ffb606" radius={[8, 8, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>

                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Batafsil jadval</h3>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <div style={{ overflowX: "auto" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr style={{ background: "#ffb606", color: "#fff" }}>
                                            <th style={{ padding: "12px", textAlign: "left" }}>Metod</th>
                                            {Object.values(metricLabels).map((l) => (
                                                <th key={l} style={{ padding: "12px", textAlign: "center" }}>{l}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {methods.map((m, i) => (
                                            <tr key={m.id} style={{ borderBottom: "1px solid #eee", background: i % 2 ? "#fafafa" : "#fff" }}>
                                                <td style={{ padding: "12px", fontWeight: 600 }}>{m.name}</td>
                                                {Object.keys(metricLabels).map((k) => (
                                                    <td key={k} style={{ padding: "12px", textAlign: "center" }}>{m.metrics[k]}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default MethodCompare;
